export default "__VITE_ASSET__D0aRR0UV__"